import React from 'react'
import Preloader from '../../Global/Preloader';
import Headertwo from '../../Global/Headertwo';
import Blogbred from '../../Global/Blogbred';
import Teamdetails from '../Mainblogdetails/Teamdetail';
import Ctaone from '../../Global/Ctaone';
import Footer from '../../Global/Footer';
import BackToTop from '../../Global/BackToTop';

const Main = () => {
    return (    
        <>
        {/* <Preloader/> */}
            <Headertwo />
            <Blogbred title="7 Essential Personal Finance Tips for NRIs You Need to Know"/>
            <Teamdetails/>
            {/* <Ctaone/> */}
            <Footer/>
            <BackToTop/>
        </>
    )
}
export default Main;